import { render, staticRenderFns } from "./FileDocument.vue?vue&type=template&id=2fda5ff8"
import script from "./js/fileDocument.js?vue&type=script&lang=js&external"
export * from "./js/fileDocument.js?vue&type=script&lang=js&external"
import style0 from "./FileDocument.vue?vue&type=style&index=0&id=2fda5ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports